import {GenericReactForm, SubmitButton, SelectCollectionInput, FormActions} from 'client/js/util/form_utils';
import Callout from 'client/js/util/callout';
import {useResource} from 'client/js/util/rest_utils';
import {useState} from 'react';

const SuccessMessage = function() {
  return <Callout calloutClass="success" title="CD-ISO geändert">
      <p>Das CD-ISO wurde erfolgreich geändert. Die neue CD steht ab sofort in der virtuellen Maschine zur Verfügung.</p>
    </Callout>;
}

const ChangeIsoForm = ({match}) => {
  const id = match.params.id;
  const [success, setSuccess] = useState(false);

  const { data, component } = useResource(['virtual_machines', id, "change_iso"], `/usercp/virtual_machines/${id}/change_iso`, {
    keepPreviousData: true,
  });

  if(component)
    return component;

  if(success)
    return <SuccessMessage />;

  const currentTemplate = data.current_template;

  return (
    <GenericReactForm
      defaults={{template_id: data.current_template?.id}}
      namespace="usercp_cloud_change_iso"
      url={`/usercp/virtual_machines/${id}/change_iso.json`}
      onSuccess={() => setSuccess(true)}>

      <div className="row form-group ">
        <div className="col-md-3">
          Aktuelles CD-Image:
        </div>
        <div className="col-md-9">
          {currentTemplate ? (
            <>
              {currentTemplate.title} {currentTemplate.private && <span className="badge badge-secondary ml-2">Privat</span>}
            </>
          ) : (
            <span className="text-muted">Kein CD-Image ausgewählt</span>
          )}
        </div>
      </div>

      <SelectCollectionInput
        clearable
        name="template_id"
        label="CD-Image"
        raw_options={data.templates.map((t) => ({
          value: t.id,
          label: (
            <span>
              {t.title}
              {t.private && <span className="badge badge-secondary badge-baseline ml-2">Privat</span>}
            </span>
          )
        }))}
      />

      <FormActions>
        <SubmitButton icon="exchange" text="CD-ISO wechseln" />
      </FormActions>
    </GenericReactForm>
  );
}

export default ChangeIsoForm;
